import _extends from '@babel/runtime/helpers/extends';
import React__default, { isValidElement } from 'react';
import styled, { css } from 'styled-components';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { s as srOnlyMixin } from '../theme/style-mixins/srOnly-D3ByQyko.js';
import { T as Tag } from '../Tag/Tag-CHAT4daQ.js';
import { a as TaktIdConsumer } from '../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';
import { i as isString } from '../LocalModules/storm-ui-utils/dist/esm/isString-D4CFRAVS-D4CFRAVS.js';
import { i as isFunction } from '../LocalModules/storm-ui-utils/dist/esm/isFunction-DjxTmSal-DjxTmSal.js';

/**
 * We want to render react nodes *OR* run a render prop function is that is what we are given.
 */
function returnElementOrRunRenderable(renderable, ...rest) {
  if (/*#__PURE__*/isValidElement(renderable) || isString(renderable)) {
    return renderable;
  }
  if (isFunction(renderable)) {
    return renderable(...rest);
  }
  return null;
}
const InputLabelWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40027066__sc-17en7ap-0"
})(["display:inline-flex;gap:3px;"]);
const StyledLabel = /*#__PURE__*/styled.label.withConfig({
  componentId: "sc-storm-ui-40027066__sc-17en7ap-1"
})(["box-sizing:border-box;cursor:pointer;display:inline-flex;padding-inline-start:0;padding-block-end:0;font:", ";font-weight:", ";color:", ";", " ", "{margin:0;}", " ", ""], ({
  theme
}) => theme.font.text.base.default, ({
  theme
}) => theme.font.weight.bold, ({
  theme
}) => theme.text.color.default, isMobile(css(["font:", ";font-weight:", ";"], ({
  theme
}) => theme.font.text.base.mobile, ({
  theme
}) => theme.font.weight.bold)), Tag, ({
  $disabled
}) => $disabled && css(["cursor:not-allowed;outline:none;color:", ";"], ({
  theme
}) => theme.text.color.unavailable), ({
  $hidden
}) => $hidden && srOnlyMixin);
const InputLabel = ({
  htmlFor,
  renderAs = 'label',
  onLabelClick,
  children,
  className = '',
  renderLabelStart,
  renderLabelEnd,
  innerRef,
  taktId,
  taktValue,
  disabled,
  hidden,
  ...rest
}) => /*#__PURE__*/React__default.createElement(TaktIdConsumer, {
  taktId: taktId,
  taktValue: taktValue,
  fallbackId: createStormTaktId('label-line')
}, ({
  getDataTaktAttributes
}) => /*#__PURE__*/React__default.createElement(React__default.Fragment, null, !!renderLabelStart || !!renderLabelEnd ? /*#__PURE__*/React__default.createElement(InputLabelWrapper, _extends({
  className: className
}, getDataTaktAttributes()), !!renderLabelStart && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, returnElementOrRunRenderable(renderLabelStart), ' '), /*#__PURE__*/React__default.createElement(StyledLabel, _extends({}, rest, {
  as: renderAs,
  ref: innerRef,
  $disabled: disabled,
  $hidden: hidden
}, isString(htmlFor) ? {
  htmlFor
} : {
  onClick: onLabelClick
}), children), !!renderLabelEnd && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, ' ', returnElementOrRunRenderable(renderLabelEnd))) : /*#__PURE__*/React__default.createElement(StyledLabel, _extends({}, rest, getDataTaktAttributes(), {
  as: renderAs,
  ref: innerRef,
  className: className,
  $disabled: disabled,
  $hidden: hidden
}, isString(htmlFor) ? {
  htmlFor
} : {
  onClick: onLabelClick
}), children)));

export { InputLabel as I };
//# sourceMappingURL=InputLabel-Dnf2KXR4.js.map
